import { useQuery } from '@tanstack/react-query';

import { fetchDosespotPatientInfoByUserId } from '../api/getDosespotPatientInfoByUserId.js';
import { rxKeys } from './keys.js';

export function dosespotPatientInfoQueryDefinition(userId: string) {
  return {
    queryKey: rxKeys.dosespotPatientInfo(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchDosespotPatientInfoByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load DoseSpot patient info',
        description: 'DoseSpot patient info could not be fetched.',
      },
    },
  } as const;
}

export function useDosespotPatientInfoQuery(userId: string | undefined) {
  return useQuery({
    ...dosespotPatientInfoQueryDefinition(userId ?? ''),
    enabled: !!userId,
  });
}
